<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="金额" name="oneTable">
      </el-tab-pane>
      <el-tab-pane label="人数" name="twoTable">
      </el-tab-pane>
      <el-tab-pane label="成交次数" name="threeTable">
      </el-tab-pane>
    </el-tabs>
    <OneEcherts class="echerts" v-if="activeName === 'oneTable'" />
    <TwoEcherts class="echerts" v-if="activeName === 'twoTable'" />
    <ThreeEcherts class="echerts" v-if="activeName === 'threeTable'" />
  </div>
</template>

<script>
import OneEcherts from "../line1";
import TwoEcherts from "../line2";
import ThreeEcherts from "../line3";
export default {
  data() {
    return {
      activeName: "oneTable",
    };
  },
  components: { OneEcherts, TwoEcherts, ThreeEcherts },
  methods: {
    handleClick(tab, event) {
      this.$emit("refreshEcherts", tab.name);
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="less" scoped>
.echerts {
  width: 100%;
  height: 400px;
  box-sizing: border-box;
}
</style>
